import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import PratusTable from 'components/DesignSystems/PratusTable/PratusTable';
import { useMemo } from 'react';
import { WorkGroupResourceNeed } from './AssignmentList';

const AssignmentCardResourceNeeds = ({
  workGroupResourceNeeds,
}: {
  workGroupResourceNeeds: WorkGroupResourceNeed[];
}) => {
  const columnHelper = createColumnHelper<WorkGroupResourceNeed>();
  const resourceNeedColumns = useMemo<ColumnDef<WorkGroupResourceNeed, any>[]>(
    () => [
      columnHelper.accessor('resourceName', {
        id: 'resourceName',
        header: () => <span>Resource Name</span>,
        enableSorting: true,
        cell: (info) => {
          const row = info.row.original;
          return <span>{row.resourceName}</span>;
        },
        meta: { align: 'left' },
      }),
      columnHelper.accessor('required', {
        id: 'required',
        header: () => <span>Required</span>,
        enableSorting: true,
        cell: (info) => {
          const row = info.row.original;
          return <span>{row.required}</span>;
        },
        meta: { align: 'left' },
      }),
      columnHelper.accessor('workAssignmentName', {
        id: 'workAssignment',
        header: () => <span>Work Assignment</span>,
        enableSorting: true,
        cell: (info) => {
          const row = info.row.original;
          return <span>{row.workAssignmentName}</span>;
        },
        meta: { align: 'left' },
      }),
    ],
    [columnHelper]
  );

  return (
    <PratusTable
      className={'layout-auto pratus-table'}
      columns={resourceNeedColumns}
      data={workGroupResourceNeeds}
      getRowId={(row) => row.id}
      noDataIndication={
        <div className="d-flex justify-content-center flex-column align-items-center p-3">
          <div>No objectives yet</div>
          <div>{`Click "Add Objective" to create your first objective`}</div>
        </div>
      }
    />
  );
};

export default AssignmentCardResourceNeeds;
